function loadPortfolioView(view) {
    return () => import( /* webpackChunkName: "portfolio-[request]" */ `../views/Portfolio/${view}.vue`)
}

const routes = [
    {
        path: '/portfolio',
        name: 'PortfolioGroup',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['mahasiswa']
        },
        component: loadPortfolioView('PortfolioGroup')
    },
    {
        path: '/portfolio/:portfolio_group_id',
        name: 'Portfolio',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['mahasiswa']
        },
        component: loadPortfolioView('Portfolio')
    },
    {
        path: '/portfolio/:portfolio_group_id/:portfolio_id',
        name: 'PortfolioDetail',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['mahasiswa']
        },
        component: loadPortfolioView('PortfolioDetail')
    },
    {
        path: '/portfolio-study-course',
        name: 'PortfolioStudyCourse',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kadep']
        },
        component: loadPortfolioView('PortfolioStudyCourse')
    },
    {
        path: '/portfolio-category',
        name: 'PortfolioType',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kadep']
        },
        component: loadPortfolioView('PortfolioType')
    },
    {
        path: '/portfolio-topic',
        name: 'PortfolioTopic',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kadep']
        },
        component: loadPortfolioView('PortfolioTopic')
    },
    {
        path: '/portfolio-list',
        name: 'ListPortfolio',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kadep']
        },
        component: loadPortfolioView('ListPortfolio')
    },
    {
        path: '/portfolio-list/:portfolio_id',
        name: 'ListPortfolioDetail',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kadep']
        },
        component: loadPortfolioView('PortfolioDetail')
    },
    {
        path: '/portfolio-user-list',
        name: 'ListUserPortfolio',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kadep']
        },
        component: loadPortfolioView('ListUserPortfolio')
    },
    {
        path: '/portfolio-user-list/:npm',
        name: 'ListUserPortfolioGroup',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kadep']
        },
        component: loadPortfolioView('ListPortfolio')
    },
    {
        path: '/portfolio-user-list/:npm/:portfolio_id',
        name: 'ListUserPortfolioGroupDetail',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kadep']
        },
        component: loadPortfolioView('PortfolioDetail')
    },
    {
        path: '/portfolio-fame',
        name: 'PortfolioFrame',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kadep']
        },
        component: loadPortfolioView('PortfolioFrame')
    },
    {
        path: '/portfolio-slider',
        name: 'PortfolioSlider',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kadep']
        },
        component: loadPortfolioView('PortfolioSlider')
    },
]

export default routes